/**
 * @generated SignedSource<<3355166ec840d95a06ea328d463a11cf>>
 * @relayHash 8ea2fa4b5feb7c77a65a15a2938c86e5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4c2e3cad816db26d978504a80e58c3c615d8721ae7f60f98c9409e2603174b10

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CodingAgentListInstalledAgentsQuery$variables = {
  cloudId: string;
};
export type CodingAgentListInstalledAgentsQuery$data = {
  readonly jira: {
    readonly jira_getAvailableCodingAgents: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly agent?: {
            readonly actionsRef?: {
              readonly " $fragmentSpreads": FragmentRefs<"AgentCardActions_StudioBrowseKit">;
            } | null;
            readonly id?: string;
            readonly name?: string | null;
          } | null;
          readonly user?: {
            readonly name: string;
          } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};
export type CodingAgentListInstalledAgentsQuery = {
  response: CodingAgentListInstalledAgentsQuery$data;
  variables: CodingAgentListInstalledAgentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CodingAgentListInstalledAgentsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraActorConnection",
            "kind": "LinkedField",
            "name": "jira_getAvailableCodingAgents",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraActorEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "agent",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v3/*: any*/),
                                  (v2/*: any*/),
                                  {
                                    "fragment": {
                                      "kind": "InlineFragment",
                                      "selections": [
                                        {
                                          "kind": "FragmentSpread",
                                          "name": "AgentCardActions_StudioBrowseKit"
                                        }
                                      ],
                                      "type": "AgentStudioAssistant"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "actionsRef"
                                  }
                                ],
                                "type": "AgentStudioAssistant"
                              }
                            ]
                          }
                        ],
                        "type": "JiraAgenticUser"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CodingAgentListInstalledAgentsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraActorConnection",
            "kind": "LinkedField",
            "name": "jira_getAvailableCodingAgents",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraActorEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v2/*: any*/),
                              (v3/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "agent",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v3/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                  },
                                  {
                                    "kind": "ClientExtension",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "__id"
                                      }
                                    ]
                                  }
                                ],
                                "type": "AgentStudioAssistant"
                              }
                            ]
                          }
                        ],
                        "type": "JiraAgenticUser"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4c2e3cad816db26d978504a80e58c3c615d8721ae7f60f98c9409e2603174b10",
    "metadata": {},
    "name": "CodingAgentListInstalledAgentsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9e0c010b5017aed3212aea93372e3620";

export default node;
